import script from "./SummaryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryTable.vue?vue&type=script&setup=true&lang=js"

import "./SummaryTable.vue?vue&type=style&index=0&id=dd3e2618&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd3e2618"]])

export default __exports__